import React from "react";
import { NavLink } from "react-router-dom";

export interface AccompagnementCardProps {
  /** Image d'illustration de la carte */
  image: string;
  /** Icône affichée au-dessus du titre (emoji ou élément React, ex: <FiLeaf />) */
  icon: React.ReactNode;
  /** Titre de l'accompagnement */
  title: string;
  /** Courte description */
  description: string;
  /** Texte du lien en bas de carte (ex: "Découvrir nos produits") */
  linkText: string;
  /** Route vers laquelle le lien pointe */
  to: string;
}

export const AccompagnementCard: React.FC<AccompagnementCardProps> = ({
  image,
  icon,
  title,
  description,
  linkText,
  to,
}) => {
  return (
    <div className="accompagnement-card">
      <NavLink to={to} className="accompagnement-card-image-overlay" aria-label={title} />

      <div className="accompagnement-card-image-wrapper">
        <img
          loading="lazy"
          src={image}
          alt={title}
          className="accompagnement-card-image"
        />
      </div>

      <div className="accompagnement-card-body">
        <div className="accompagnement-card-icon" aria-hidden="true">
          {icon}
        </div>

        <h3 className="accompagnement-card-title">{title}</h3>

        <p className="accompagnement-card-desc">{description}</p>

        <NavLink to={to} className="accompagnement-card-link">
          {linkText} <span aria-hidden="true">→</span>
        </NavLink>
      </div>
    </div>
  );
};

export default AccompagnementCard;